<template>
    <generic-page>
        <b-btn variant="link" size="lg" class="pl-0" to="/withdraw/index">
            <font-awesome-icon size="lg" icon="fa-light fa-chevron-left" />
            {{ $t("Back") }}
        </b-btn>

        <div class="d-flex align-items-center justify-content-between">
            <h5>
                {{ $t("Redemption Details") }}
            </h5>

            <b-btn
                :disabled="refreshing"
                @click="refresh"
                variant="light"
                class="border"
                size="sm"
                pill
            >
                <div v-if="refreshing">
                    <b-spinner small />
                </div>
                <div v-else>
                    <font-awesome-icon icon="fa-light fa-arrows-rotate" />
                    {{ $t("Refresh") }}
                </div>
            </b-btn>
        </div>

        <div v-if="withdraw">
            <b-alert
                variant="warning"
                show
                v-if="withdraw.maxFeeAllowed && !withdraw.fulfilledAt"
                class="mt-3"
            >
                <h5 class="mb-0">
                    {{ $t("Transfer Pending") }}
                </h5>

                <b-table-simple bordered class="mt-2">
                    <tbody>
                        <tr>
                            <th class="bg-light w-50">
                                {{ $t("Current Fee") }}
                            </th>
                            <td class="bg-white text-warning">
                                ${{ withdrawDetail.withdrawFee }}
                            </td>
                        </tr>
                        <tr>
                            <th class="bg-light w-50">
                                {{ $t("Max Fee Allowed") }}
                            </th>
                            <td class="bg-white">
                                ${{ withdraw.maxFeeAllowed }}
                            </td>
                        </tr>
                    </tbody>
                </b-table-simple>

                <div class="small">
                    <font-awesome-icon icon="fa-duotone fa-info-circle" />
                    {{
                        $t(
                            "Transfer fees are expensive right now due to high network traffic. Our system will start the transfer as soon as the fees return to normal to make sure you get the maximum payout. Fees usually return to normal levels within a few hours"
                        )
                    }}
                </div>

                <div class="mt-2">
                    <b-button
                        v-b-toggle.acceptHighFees
                        variant="light"
                        pill
                        block
                    >
                        {{ $t("Start Transfer Now") }}
                        <div class="text-warning small">
                            {{ $t("Not Recommended") }}
                        </div>
                    </b-button>
                    <b-collapse id="acceptHighFees">
                        <h5 class="mt-3">
                            {{ $t("Are you sure?") }}
                        </h5>
                        <div>
                            {{
                                $t(
                                    "If you wait a few hours, the fees are likely to come down, however, if you are OK with the fee you can transfer now if you like"
                                )
                            }}
                        </div>
                        <b-button
                            v-b-toggle.acceptHighFees
                            variant="primary"
                            pill
                            block
                            class="mt-3"
                        >
                            {{ $t("Wait for Lower Fees") }}
                            <div class="small">
                                {{ $t("Strongly Recommended") }}
                            </div>
                        </b-button>
                        <b-button
                            @click="acceptHighFees"
                            variant="light"
                            pill
                            block
                        >
                            {{ $t("Start Transfer") }}
                            <div class="text-warning small">
                                {{ $t("Accept Fee:") }}
                                ${{ withdrawDetail.withdrawFee }}
                            </div>
                        </b-button>
                    </b-collapse>
                </div>
            </b-alert>

            <b-table-simple class="mt-2">
                <tbody>
                    <tr>
                        <th>
                            {{ $t("Status") }}
                        </th>
                        <td class="bg-white">
                            {{ withdraw.transferStatus }}
                        </td>
                    </tr>
                    <tr>
                        <th>
                            {{ $t("Fulfillment Time") }}
                        </th>
                        <td class="bg-white">
                            {{ withdrawDetail.fulfilledAtRelative }}
                        </td>
                    </tr>
                    <tr>
                        <th>
                            {{ $t("Credits") }}
                        </th>
                        <td class="bg-white">
                            <coin-badge :amount="withdraw.amount" />
                        </td>
                    </tr>
                    <tr v-if="withdraw.jackpot">
                        <th>
                            {{ $t("Jackpot Contribution") }}
                        </th>
                        <td class="bg-white">
                            <coin-badge :amount="withdraw.jackpot" />
                        </td>
                    </tr>
                    <tr>
                        <th>
                            {{ $t("Local") }}
                        </th>
                        <td class="bg-white">~{{ withdrawDetail.local }}</td>
                    </tr>
                </tbody>
            </b-table-simple>
        </div>
        <div v-else>
            <generic-loading />
        </div>
    </generic-page>
</template>

<script>
export default {
    data() {
        return {
            withdraw: null,
            withdrawDetail: null,
            refreshing: false,
        };
    },
    mounted() {
        this.refresh();
    },
    methods: {
        acceptHighFees() {
            this.refreshing = true;

            const withdrawId = this.$route?.params?.id;

            this.api
                .post(`/withdraw/${withdrawId}/forceStart`)
                .then(() => {
                    this.refresh();
                })
                .finally(() => {
                    this.refreshing = false;
                });
        },
        refresh() {
            this.refreshing = true;

            const withdrawId = this.$route?.params?.id;

            this.api
                .post(`/withdraw/${withdrawId}/view`)
                .then((response) => {
                    this.withdraw = response.data.withdraw;
                    this.withdrawDetail = response.data.withdrawDetail;
                })
                .finally(() => {
                    // UI level throttle
                    setTimeout(() => {
                        this.refreshing = false;
                    }, 1000);
                });
        },
    },
};
</script>